import View from "../framework/view";
import template from "../../pugc/card";
import jQuery from "jquery";
import {Card, flowMessage} from "../misc/cards";
import {CARD_TRANSLATE_CLASS, writeToCanvas} from "../handwriting/write_words";
import Server from "../server";
import LocalDB from "../misc/localdb";

const classname = "card-view";

type Size = "small" | "designers-card";

const localdb = LocalDB.instance();

const BIG_CARD_KEY = "big-designers-card";
const NO_CUTTING_MARKS_KEY = "no-cutting-marks";

// Generic delete key handler

function deletePressed() {
    const cardViews = jQuery(document).find("." + classname);
    cardViews.each((idx, elt) => {
        const view = jQuery(elt).data("view") as CardView;
        view.deleteSelected();
    });
}
function undoPressed() {
    const cardViews = jQuery(document).find("." + classname);
    cardViews.each((idx, elt) => {
        const view = jQuery(elt).data("view") as CardView;
        view.undo();
    });
}

document.addEventListener("keyup", (evt) => {
    const e = document.activeElement;
    const nofocus = e === null || e === document.body || e === document.documentElement;
    const del = evt.code == "Delete" || evt.code == "Backspace";

    if (del && nofocus) {
        deletePressed();
    }
});
document.addEventListener("keyup", (evt) => {
    const e = document.activeElement;
    const nofocus = e === null || e === document.body || e === document.documentElement;
    const undo = evt.code == "KeyZ" && evt.ctrlKey;

    if (undo) {
        undoPressed();
    }
});

export interface Point {
    x: number;
    y: number;
}
export interface Transform extends Point {
    scale: number;
}

type Undo = {
    elt: JQuery<HTMLElement>,
    html: string
};

const server = Server.instance();

export class CardView extends View {

    private card?: Card;

    private originalTxt: string | undefined;

    private style : number | undefined = undefined;

    private dragStart: Point | undefined;
    private rectStart: Point | undefined;

    readonly transform = {
        x: 0,
        y: 0,
        scale: 1
    };

    private rect: SVGRectElement | undefined;

    private dragEndTimestamp : number | undefined;

    private snapshots : Undo[] = [];

    private big_designers_card : boolean = localdb.get(BIG_CARD_KEY) ? true : false;
    private noCuttingMarks : boolean = localdb.get(NO_CUTTING_MARKS_KEY) ? true : false;

    constructor(card?: Card) {
        super(classname);
        this.setCard(card);
    }

    setCard(card: Card | undefined) {
        this.card = card;
        this.originalTxt = card ? card.text : undefined;
        this.transform.scale = 1;
        this.transform.x = 0;
        this.transform.y = 0;
        this.style = undefined;
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            card: this.card,
            style: this.style,
            scale: this.transform.scale,
            size: this.card && this.card.designers_card ? "designers-card" : "small",
            canRestore: this.card && this.card.text != this.originalTxt,
            noCuttingMarks: this.noCuttingMarks,
            big_designers_card: this.big_designers_card,
        };

        const out = this.pug(template, data)

        this.afterUpdate(() => {
            this.configTransform();
        });

        return out;
    }

    async write() {

        let text = this.elt().find("textarea").val() as string;

        const canvas = this.elt().find(".canvas");

        const transform = this.calcTransform();

        await writeToCanvas(canvas[0] as any as SVGSVGElement, text, {
            styleIdx: this.style,
            transform: transform
        });

        this.configTransform();
    }

    canvasClick(canvas: JQuery<HTMLElement>, event: JQueryEventObject) {
        const nativeEvent = event.originalEvent as MouseEvent;
        const shift = nativeEvent.shiftKey;
        const ctrl = nativeEvent.ctrlKey;

        // Don't know why we are getting click events at end of drag...
        if (this.dragStart || (this.dragEndTimestamp && Math.abs(this.dragEndTimestamp - nativeEvent.timeStamp) <=1)) {
            return;
        }

        this.rectStart = undefined;
        this.rect && this.rect.remove();

        if (! shift && ! ctrl) {
            canvas.find(".wrb-selected").removeClass("wrb-selected");
        }

        const svg = canvas[0] as any;

        const a = svg.createSVGPoint();

        a.x = event.clientX;
        a.y = event.clientY;

        const paths = canvas.find("path");

        paths.each((idx, p) => {
            const box = p.getBoundingClientRect();

            // Does pox contain a?
            const contains = box.x <= a.x && box.x + box.width >= a.x && box.y <= a.y && box.y + box.height >= a.y;

            if (contains) {
                const already = p.classList.contains("wrb-selected");
                if (already) {
                    p.classList.remove("wrb-selected");
                } else {
                    p.classList.add("wrb-selected");
                }
            }
        });
    }

    drag(canvas: JQuery<HTMLElement>, event: JQueryEventObject) {

        const nativeEvent = event.originalEvent as MouseEvent;
        const shift = nativeEvent.shiftKey;
        const button = nativeEvent.buttons & 1;

        if (! shift) {

            const dragging = this.dragStart !== undefined;
            const dragstart = (event.type == "mousedown" || !dragging && button);
            const dragend = event.type == "mouseup" || !button;
            const dragmove = event.type == "mousemove";

            if (dragstart) {

                const selected = canvas.find(".wrb-selected");
                const p = this.transform;
                this.dragStart = {
                    x: event.clientX - p.x,
                    y: event.clientY - p.y
                };

                selected.each((idx, elt) => {
                    const e = jQuery(elt);
                    const s = elt as unknown as SVGSVGElement;
                    const tt = s.transform.baseVal;
                    const t = tt.length > 0 ? tt.getItem(0) : undefined;
                    e.data("dragstartx", t ? t.matrix.e : 0);
                    e.data("dragstarty", t ? t.matrix.f : 0);
                });

                this.snapshot(canvas);

            } else if (dragend) {
                const p = this.transform;
                if (this.dragStart && (event.clientX - p.x - this.dragStart.x) != 0 && (event.clientY - p.y - this.dragStart.y) != 0) {
                    this.dragEndTimestamp = nativeEvent.timeStamp;
                }
                this.dragStart = undefined;
            } else if (this.dragStart) {

                this.rectStart = undefined;
                this.rect && this.rect.remove();

                const diffX = event.clientX - this.dragStart.x;
                const diffY = event.clientY - this.dragStart.y;

                const selected = canvas.find(".wrb-selected");
                if (selected.length > 0) {
                    selected.each((idx, elt) => {
                        const e = jQuery(elt);
                        const x = e.data("dragstartx");
                        const y = e.data("dragstarty");
                        const p = this.transform;
                        e.attr("transform", `translate(${(diffX - p.x)/ p.scale + x}, ${(diffY - p.y) / p.scale + y})`);
                    });

                } else {
                    this.transform.x = diffX;
                    this.transform.y = diffY;
                    this.configTransform();
                }

            }
        }

        if (shift) {

            const dragging = this.rectStart !== undefined;
            const dragstart = (event.type == "mousedown" || !dragging && button);
            const dragend = event.type == "mouseup" || !button;

            if (dragstart) {

                this.rectStart = {
                    x: event.clientX,
                    y: event.clientY
                };

                const active = document.activeElement;
                if (active instanceof HTMLElement) {
                    active.blur();
                }

            } else if (dragend) {
                this.dragStart = undefined;

                if (this.rectStart) {
                    this.markSelected();
                }

            } else if (this.rectStart) {

                const svg = canvas[0] as any;
                const svgToScreen = svg.getScreenCTM();
                const screenToSvg = svgToScreen.inverse();

                const a = svg.createSVGPoint();
                const b = svg.createSVGPoint();

                a.x = event.clientX;
                a.y = event.clientY;

                b.x = this.rectStart.x;
                b.y = this.rectStart.y;

                const a1 = a.matrixTransform(screenToSvg);
                const b1 = b.matrixTransform(screenToSvg);

                this.rect && this.rect.remove();

                const rect = this.rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");

                rect.classList.add("delete-region");

                rect.setAttribute("x", String(Math.min(a1.x, b1.x)));
                rect.setAttribute("y", String(Math.min(a1.y, b1.y)));

                rect.setAttribute("width", String(Math.abs(a1.x - b1.x)));
                rect.setAttribute("height", String(Math.abs(a1.y - b1.y)));

                rect.setAttribute("stroke", "red");
                rect.setAttribute("stroke-dasharray", "4 2");
                rect.setAttribute("fill-opacity", "0");

                svg.appendChild(rect);
            }
        }
    }

    markSelected() {
        const rect = this.rect;

        if (! rect) {
            return;
        }
        const box = rect.getBBox();

        const canvas = this.elt().find(".canvas");
        const svg = canvas[0] as any;

        const paths = canvas.find("path");

        paths.each((idx, p) => {
            const ctm = p.getCTM();
            const pox = p.getBBox();

            const nw = svg.createSVGPoint();
            const se = svg.createSVGPoint();

            nw.x = pox.x;
            nw.y = pox.y;

            se.x = pox.x + pox.width;
            se.y = pox.y + pox.height;

            const nw2 = nw.matrixTransform(ctm);
            const se2 = se.matrixTransform(ctm);

            // Does box contain pox?
            const contains = box.x <= nw2.x && box.x + box.width >= se2.x && box.y <= nw2.y && box.y + box.height >= se2.y;
            if (contains) {
                p.classList.add("wrb-selected");
            }
        });

        this.rect?.parentNode?.removeChild(this.rect);
        this.rect = undefined;
    }

    setStyle(style: number) {
        this.style = style;
        this.update(".styles");
        this.write();
    }

    setScale(scale: number) {
        this.transform.scale = scale;
        this.configTransform();
    }

    calcTransform() {
        const p = this.transform;
        const transform = `translate(${p.x} ${p.y}) scale(${p.scale})`;
        return transform;
    }

    configTransform() {
        const transform = this.calcTransform();
        const gs = this.elt().find(`svg .${CARD_TRANSLATE_CLASS}`);
        gs.each((idx, elt) => {
            const g = jQuery(elt);
            g.attr("transform", transform);
        });
    }

    setSize(size: Size) {
        if (! this.card) {
            return;
        }
        const d = size === "designers-card";
        if (d === this.card.designers_card) {
            return;
        }
        this.card.designers_card = d;
        this.setCard(this.card);
    }

    setBigCard(big: boolean) {
        this.big_designers_card = big;
        localdb.set(BIG_CARD_KEY, big);
        this.setCard(this.card);
    }

    setNoCuttingMarks(x: boolean) {
        this.noCuttingMarks = x;
        localdb.set(NO_CUTTING_MARKS_KEY, x);
        this.setCard(this.card);
    }

    deleteSelected() {
        const canvas = this.elt().find(".canvas");

        this.snapshot(canvas);

        const select = canvas.find("path.wrb-selected");

        select.each((idx, elt) => elt.remove());

        this.rect && this.rect.remove();
        this.rectStart = undefined;
    }

    snapshot(canvas: JQuery<HTMLElement>) {
        const s = canvas.html();
        this.snapshots.push({
            elt: canvas,
            html: s
        });
    }

    undo() {
        const u = this.snapshots.length > 0 ? this.snapshots.pop() : undefined;
        if (! u) {
            return;
        }

        this.rect?.parentNode?.removeChild(this.rect);
        this.rect = undefined;

        u.elt.html(u.html);
    }

    restore() {
        if (! this.card || ! this.originalTxt) {
            return;
        }
        this.card.text = this.originalTxt;
        this.update();
    }

    updateText(t: string) {
        if (! this.card) {
            return;
        }
        const a = this.card.text == this.originalTxt;
        this.card.text = t;
        const b = this.card.text == this.originalTxt;
        if (a != b) {
            this.update(".restore-container");
        }
    }

    print() {
        if (this.card) {
            try {
                const c = this.card;
                const svg = this.elt().find(".canvas").html();

                const data = {
                    id: c.id,
                    number: c.number,
                    line: c.line,
                    text: c.text,
                    designers_card: c.designers_card,
                    svg: svg
                };

                server.savePrintCard(data);
            } catch (ex) {
                // ignore
            }

        }

        window.print();
    }
}

View.on(
    "." + classname,
    "mousedown mouseup mousemove",
    ".canvas",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const canvas = jQuery(elt).closest(".canvas").addBack(".canvas");
        that.drag(canvas, event);
    });

View.on(
    "." + classname,
    "click",
    ".canvas",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const canvas = jQuery(elt).closest(".canvas").addBack(".canvas");
        that.canvasClick(canvas, event);
    });

View.on(
    "." + classname,
    "click",
    "button.style",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const style = +(jQuery(elt).data("style"));
        that.setStyle(style);
    });

View.on(
    "." + classname,
    "input",
    "input.scale",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const scale = +(jQuery(elt).val() as number);
        that.setScale(scale);
    });

View.on(
    "." + classname,
    "change",
    "input[name=size]",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const size = jQuery(elt).val() as Size;
        that.setSize(size);
    });

View.on(
    "." + classname,
    "change",
    "input[name=big-designers-card]",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const big = jQuery(elt).is(":checked");
        that.setBigCard(big);
    });

View.on(
    "." + classname,
    "change",
    "input[name=noCuttingMarks]",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const noCuttingMarks = jQuery(elt).is(":checked");
        that.setNoCuttingMarks(noCuttingMarks);
    });

View.on(
    "." + classname,
    "input",
    "textarea",
    function(that: CardView, event, elt) {
        event.preventDefault();
        const text = jQuery(elt).val() as string;
        that.updateText(text);
    });

View.on(
    "." + classname,
    "click",
    "button.print",
    function(that: CardView, event, elt) {
        event.preventDefault();
        that.print();
    });

View.on(
    "." + classname,
    "click",
    "button.restore",
    function(that: CardView, event, elt) {
        event.preventDefault();
        that.restore();
    });

